module.exports = __webpack_public_path__ + "img/taupe.0d30aed0.jpeg";